import { Box, Button, IconButton, List, ListItemButton, ListItemText, Paper, Tooltip, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import { formatActivity } from './conversationUtils';

/** Los chats de la persona: abrir uno para retomarlo, empezar uno nuevo o quitar uno de la lista. */
export default function ConversationList({ conversations, selectedId, busy, onSelect, onNew, onHide }) {
  return (
    <Paper
      variant="outlined"
      sx={{
        display: 'flex', flexDirection: 'column', borderRadius: 2, overflow: 'hidden',
        width: { xs: '100%', md: 280 }, flexShrink: 0, maxHeight: { xs: 200, md: 'none' },
      }}
    >
      <Box sx={{ p: 1.5, borderBottom: 1, borderColor: 'divider' }}>
        <Button fullWidth variant="outlined" startIcon={<AddIcon />} onClick={onNew} disabled={busy} sx={{ textTransform: 'none' }}>
          Nueva conversación
        </Button>
      </Box>
      <List dense disablePadding sx={{ flex: 1, overflowY: 'auto' }}>
        {conversations.length === 0 && (
          <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>Todavía no tenés conversaciones guardadas.</Typography>
        )}
        {conversations.map((conversation) => (
          <ListItemButton
            key={conversation.conversationId}
            selected={conversation.conversationId === selectedId}
            disabled={busy}
            onClick={() => onSelect(conversation.conversationId)}
            sx={{ alignItems: 'flex-start', pr: 6, '& .hide-chat': { opacity: 0 }, '&:hover .hide-chat, &.Mui-selected .hide-chat': { opacity: 1 } }}
          >
            <ListItemText
              primary={conversation.title}
              secondary={`${formatActivity(conversation.lastActivity)} · ${conversation.messageCount} ${conversation.messageCount === 1 ? 'pregunta' : 'preguntas'}`}
              primaryTypographyProps={{ noWrap: true, fontWeight: conversation.conversationId === selectedId ? 700 : 400 }}
              secondaryTypographyProps={{ noWrap: true }}
            />
            <Tooltip title="Quitar de la lista">
              <IconButton
                className="hide-chat" size="small" aria-label="Quitar de la lista"
                sx={{ position: 'absolute', right: 8, top: 10 }}
                onClick={(event) => { event.stopPropagation(); onHide(conversation); }}
              >
                <DeleteOutlineIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </ListItemButton>
        ))}
      </List>
    </Paper>
  );
}
